import React, { useState } from 'react';
import { FaCheck, FaCopy, FaTimes } from 'react-icons/fa';
import { buildResetPasswordCredentialsCopyText } from '../accountCreationHelpers';

const COPY_FEEDBACK_MS = 1800;

const ResetPasswordSuccessModal = ({ credentials, onDone }) => {
  const [copiedField, setCopiedField] = useState('');

  if (!credentials) {
    return null;
  }

  const { fullName, email, username, password } = credentials;

  const copyToClipboard = async (value, fieldKey) => {
    if (!value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      setCopiedField(fieldKey);
      window.setTimeout(() => {
        setCopiedField((current) => (current === fieldKey ? '' : current));
      }, COPY_FEEDBACK_MS);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = value;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopiedField(fieldKey);
      window.setTimeout(() => {
        setCopiedField((current) => (current === fieldKey ? '' : current));
      }, COPY_FEEDBACK_MS);
    }
  };

  const handleCopyCredentials = () => {
    copyToClipboard(buildResetPasswordCredentialsCopyText(username, password), 'all');
  };

  const renderCopyButton = (value, fieldKey, label) => (
    <button
      type="button"
      className="admin-users-create-success__copy-button"
      onClick={() => copyToClipboard(value, fieldKey)}
      aria-label={`Copy ${label}`}
    >
      <FaCopy />
      {copiedField === fieldKey && (
        <span className="admin-users-create-success__copied">Copied</span>
      )}
    </button>
  );

  return (
    <div className="admin-users-modal-overlay">
      <div
        className="admin-users-modal admin-users-modal--create-success"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="reset-password-success-title"
      >
        <div className="admin-users-modal__header">
          <div className="admin-users-create-success__header-content">
            <div className="admin-users-create-success__icon">
              <FaCheck />
            </div>
            <div>
              <h2 className="admin-users-modal__title" id="reset-password-success-title">
                Password Reset Successfully
              </h2>
              <p className="admin-users-create-modal__subtitle">
                The password has been reset for:
              </p>
              <p className="admin-users-create-success__user">
                {fullName}
                <span>{email}</span>
              </p>
            </div>
          </div>
          <button
            type="button"
            className="admin-users-modal__icon-button"
            onClick={onDone}
            aria-label="Close success modal"
          >
            <FaTimes />
          </button>
        </div>

        <div className="admin-users-modal__body">
          <div className="admin-users-create-success__credentials">
            <h3 className="admin-users-modal__section-title">Login Credentials</h3>

            <div className="admin-users-create-success__credential-row">
              <div>
                <span className="admin-users-modal__label">Username</span>
                <span className="admin-users-create-success__value">{username}</span>
              </div>
              {renderCopyButton(username, 'username', 'username')}
            </div>

            <div className="admin-users-create-success__credential-row">
              <div>
                <span className="admin-users-modal__label">New Temporary Password</span>
                <span className="admin-users-create-success__value">{password}</span>
              </div>
              {renderCopyButton(password, 'password', 'password')}
            </div>

            <button
              type="button"
              className="admin-users-create-success__copy-all"
              onClick={handleCopyCredentials}
            >
              <FaCopy />
              Copy Credentials
              {copiedField === 'all' && (
                <span className="admin-users-create-success__copied">Copied</span>
              )}
            </button>
          </div>
        </div>

        <div className="admin-users-modal__footer">
          <div className="admin-users-modal__footer-group admin-users-modal__footer-group--right">
            <button
              type="button"
              className="admin-users-modal__button admin-users-modal__button--primary"
              onClick={onDone}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSuccessModal;
